interface HoneypotFieldProps {
  value: string;
  onChange: (value: string) => void;
}

/**
 * A real, standard anti-bot technique — NOT a substitute for ZP-61's
 * reCAPTCHA pipeline (that ticket is captured as "not implemented," see its
 * jira file). This is honestly a different, distinct mechanism: an empty
 * field bots auto-fill and humans never see, genuinely hidden from both
 * sighted users (visually off-screen) and assistive tech (aria-hidden +
 * tabIndex -1 + not a real label), not a fake reCAPTCHA badge. The caller
 * should silently drop the submission (not show an error) if this field is
 * non-empty on submit — never reveal to a bot why it was rejected.
 */
export default function HoneypotField({ value, onChange }: HoneypotFieldProps) {
  return (
    <input
      type="text"
      name="company_website"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      tabIndex={-1}
      autoComplete="off"
      aria-hidden="true"
      className="absolute h-0 w-0 opacity-0"
      style={{ left: "-9999px" }}
    />
  );
}
